export interface IConfigOnboarding {
  actionUrl?: string;
  isCompleted: boolean;
  isLegalConsentGranted: boolean;
}
